import { Sequences } from '@/utils/permissions'
import { toBrazilianDateTime } from '@/mixins/convertion'

export function data() {
  return {
    filters: { toBrazilianDateTime },
    Sequences,
  }
}
